import React from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import {__} from 'js/tool/page/current';
import FacebookLogin from 'react-facebook-login';
import {AuthContext} from 'js/reusable/auth/authContext';
import {setTestId} from 'js/reusable/testing/setTestId';
import {FacebookLoginResponse, FbLoginFunc, ValidationErrors} from 'js/reusable/auth/types';
import Spinner from 'js/reusable/loading';

type IProps = {
	loading: boolean;
	policy: boolean;
	validationErrors?: ValidationErrors | null;
}

const fbAppId      = import.meta.env.REACT_APP_FB_APP_ID ?? '';
const fbAPIVersion = '25.0';

function FacebookLoginForm({loading, policy, validationErrors}: IProps) {
	function onFacebookLogin(login: FbLoginFunc) {
		return function (fbResponse: FacebookLoginResponse) {
			login({...fbResponse, policy: policy || undefined});
		};
	}

	return (
		<Form.Row>
			<Form.Group as={Col}>
				<AuthContext.Consumer>
					{({fbLogin: login}) => (
						<div
							data-testid={setTestId('login-facebook')}
						>
							<FacebookLogin
								appId={fbAppId}
								callback={onFacebookLogin(login)}
								cssClass="btn btn-primary facebook-login-btn"
								icon={
									loading ? <Spinner /> : <i className="fab fa-facebook-square" />
								}
								version={fbAPIVersion}
								isDisabled={loading || !!(validationErrors?.fb_policy && !policy)}
								// @ts-ignore: prop missing in TS declaration
								isProcessing={loading}
							/>
						</div>
					)}
				</AuthContext.Consumer>

				<Form.Control.Feedback
					type="invalid"
					style={{display: validationErrors && validationErrors.sso_login ? 'block' : ''}}
				>
					{__(validationErrors ? validationErrors.sso_login : '')}
				</Form.Control.Feedback>
			</Form.Group>
		</Form.Row>
	);
}

export default FacebookLoginForm;
